<template>
  <div @click="routerPush" class="body-card-news">
    <div class="image-news-main mr-10">
      <img
        @error="handleImageError()"
        class="image"
        :src="banner"
        :alt="banner"
      />
    </div>
    <div class="content" style="cursor: pointer">
      <p class="facility-name m-0  c-caption">
        {{ title }}
      </p>
      <p class="c-tiny des-facility mt-5">
        {{ excerpt }}
      </p>
      <div class="desktop mt-10 ">
        <div class="d-flex align-items-center">
          <el-avatar
            style="border: 1px solid #1B4684;"
            class="flex-shrink-0"
            :size="30"
            :src="objectData.author_info.avatar"
          >
          </el-avatar>
          <div class="ml-10 d-flex flex-column">
            <span class="mt-1 c-tiny fw-600 lh-18">{{ authorName }}</span>
            <span class="c-tiny m-0  p-0">{{ objectData.created_at }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBackGround } from "../../../utils/wapAuth";

export default {
  bodyClass: "card-facilities",
  components: {},
  props: {
    objectData: {
      type: Object,
      default() {
        return {};
      }
    },
    title: {
      default: ""
    },
    excerpt: {
      default: ""
    },
    banner: {
      default:
        "https://web-api.vcallid.com/static/uploads/03126e45-475d-4882-a01f-7a3cfaf90f3f.png"
    },
    id: {
      default: ""
    },
    authorName: {
      default: ""
    }
  },
  watch: {},
  data() {
    return {
      bg: getBackGround()
    };
  },
  computed: {},
  methods: {
    routerPush() {
      return this.$router.push(`/tin-tuc/chi-tiet/${this.id}`);
    },
    handleImageError() {
      return "https://web-api.vcallid.com/static/uploads/03126e45-475d-4882-a01f-7a3cfaf90f3f.png";
    }
  }
};
</script>
<style lang="scss"></style>

<style scoped lang="scss">
.mr-10 {
  margin-right: 10px;
}

.content {
  max-width: 100%;
}

.full-width {
  width: 100%;
}

.image-news-main {
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
  height: 148px;
  width: 240px;
  border-radius: 5px;
  .image {
    user-drag: none; /* Safari */
    -webkit-user-drag: none; /* Chrome, Safari, Edge */
    -moz-user-select: none; /* Firefox */
    user-select: none; /* Ngăn chọn ảnh */
    pointer-events: auto; /* Vẫn cho click */
    width: 100%;
    height: 100%;
    border-radius: 5px;
    object-fit: cover; /* giữ toàn bộ ảnh, không bị crop */
    object-position: center;
  }
}
.body-card-news {
  display: flex;
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  border: none;
  margin-bottom: 10px;
}

.text-left {
  width: 100%;
  text-align: left;
}

.mb-0 {
  margin-bottom: 0;
}
.facility-name {
  font-weight: 600;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Số dòng giới hạn */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 18px;
  margin: 0;
}
.des-facility {
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Số dòng giới hạn */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 15px;
  margin: 0;
}
.desktop {
  display: block;
}
.mobile {
  display: none;
}
@media screen and (min-width: 0px) and (max-width: 580px) {
  .image-news-main {
    width: 113px;
    height: 65px;
  }
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
  .content {
    max-width: 300px;
  }
  .body-card-news {
    position: relative;
    overflow: hidden;
    border-radius: 6px;
    margin-bottom: 10px;
    width: 238px;
    padding: 10px;
    box-shadow: 0px 0px 4px 0px #00000026;
  }
  .facility-name {
    height: 37px;
  }
}
</style>
